<div class="ui-g items-block ">
    <div class="card card-w-title">
        <div class="items-content  p-p-3">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>